import React from "react";
import { Alert } from "reactstrap";
import { Link } from "react-router-dom";

const SubscriptionsSlaUpgradeAlert = ({ color = "warning" }) => (
  <Alert color={color}>
    Subscriptions are offered with <Link to="/sla">Business or Gold Plan SLA</Link> only.
    Please <Link to="/sla">upgrade your SLA</Link> in order to avail this feature.
  </Alert>
);

export default SubscriptionsSlaUpgradeAlert;
